import { c as _c } from "react/compiler-runtime";
import { BLOGS_API } from 'modules/blogs/api/blog-api';
import { BlogCategoriesApiInterface } from 'modules/blogs/types/blog-categories-interface';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
import { CountInterface, SwrPaginationInterface } from 'shared/types/pagination-interface';
import { baseFetcher } from 'shared/utils/http-client';
import useSWR from 'swr';
interface UseBlogCategoriesInterface extends SwrPaginationInterface {
  id: string;
  needFetch?: boolean;
}
export function useBlogCategories(t0) {
  const $ = _c(13);
  const {
    id,
    pagination,
    limit
  } = t0;
  const {
    user
  } = useUser();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    fetcher
  } = useFetch(t1);
  let t2;
  if ($[1] !== id || $[2] !== limit || $[3] !== pagination || $[4] !== user) {
    t2 = () => {
      if (user && pagination.startFromId === undefined && limit) {
        return `${BLOGS_API}/${id}/categories/list?pagination[limit]=${limit}`;
      } else {
        if (user && pagination.startFromId && limit) {
          return `${BLOGS_API}/${id}/categories/list?pagination[startFrom]=${pagination.startFromId}&pagination[order]=${pagination.order}&pagination[limit]=${limit}`;
        }
      }
      return null;
    };
    $[1] = id;
    $[2] = limit;
    $[3] = pagination;
    $[4] = user;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const {
    data: blogCategories,
    mutate: blogCategoriesMutate
  } = useSWR(t2, fetcher);
  let t3;
  if ($[6] !== id || $[7] !== user) {
    t3 = () => {
      if (user) {
        return `${BLOGS_API}/${id}/categories/count?pagination[limit]`;
      }
      return null;
    };
    $[6] = id;
    $[7] = user;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const {
    data: blogCategoriesCounter
  } = useSWR(t3, baseFetcher);
  let t4;
  if ($[9] !== blogCategories || $[10] !== blogCategoriesCounter || $[11] !== blogCategoriesMutate) {
    t4 = {
      blogCategories,
      blogCategoriesMutate,
      blogCategoriesCounter
    };
    $[9] = blogCategories;
    $[10] = blogCategoriesCounter;
    $[11] = blogCategoriesMutate;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
}